export const ROUTE = {
    HOME:'/',
    SEARCH: '/search',
    LOGIN: '/login',
    REGISTER: '/register',
    PROFILE: '/profile',
    DETAIL: {
        ROOT:'/detail',
        PERSON: '/person/:personId',
        MOVIE: '/movie/:movieId',
        TVSHOW: '/tv/:tvId',
    }
}